// extracted by mini-css-extract-plugin
module.exports = {"tariffsLayout":"FacilityTariffs_tariffsLayout__FykJ4"};